import Microgame from '../engine/Microgame.js';

export default class PetGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Caresse !`, en: `Pet!`, es: `¡Acaricia!` },
            controls: { fr: `Frotte doucement l'animal de gauche à droite`, en: `Gently rub the animal back and forth`, es: `Frota suavemente al animal de lado a lado` },
            objective: { fr: `Remplis la jauge de bonheur de l'animal`, en: `Fill the animal's happiness gauge`, es: `Llena la barra de felicidad del animal` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M12 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z"/><path d="M12 22s-8-4.5-8-10V9"/><path d="M12 22s8-4.5 8-10V9"/></svg>`,
            actions: [
                { type: 'swipe', fromX: 38, fromY: 50, toX: 62, toY: 50, duration: 220 },
                { type: 'swipe', fromX: 62, fromY: 50, toX: 38, toY: 50, duration: 220 },
                { type: 'swipe', fromX: 38, fromY: 54, toX: 62, toY: 54, duration: 220 },
                { type: 'swipe', fromX: 62, fromY: 54, toX: 38, toY: 54, duration: 220 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.robot = null;
        this.rubAmount = 0;
        this.isRubbing = false;
        this.lastX = 0;
        this.lastY = 0;

        // Give 200ms more time at max speed
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * (2.8 / 3);
        this.duration = 3000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "SOOTHE!";

        // Robot Head (Primary)
        this.robot = document.createElement('div');
        this.robot.style.position = 'absolute';
        this.robot.style.width = '150px';
        this.robot.style.height = '120px';
        this.robot.style.background = this.primaryColor;
        this.robot.style.borderRadius = '20px';
        this.robot.style.left = '50%';
        this.robot.style.top = '50%';
        this.robot.style.transform = 'translate(-50%, -50%)';
        this.robot.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.robot.style.display = 'flex';
        this.robot.style.justifyContent = 'center';
        this.robot.style.alignItems = 'center';
        this.robot.style.animation = 'shake 0.2s infinite'; // Shaking because angry/upset
        this.container.appendChild(this.robot);

        // Eyes (Black)
        const eyeL = document.createElement('div');
        eyeL.style.width = '30px';
        eyeL.style.height = '30px';
        eyeL.style.background = '#000';
        eyeL.style.borderRadius = '50%';
        eyeL.style.margin = '0 15px';
        this.robot.appendChild(eyeL);

        const eyeR = document.createElement('div');
        eyeR.style.width = '30px';
        eyeR.style.height = '30px';
        eyeR.style.background = '#000';
        eyeR.style.borderRadius = '50%';
        eyeR.style.margin = '0 15px';
        this.robot.appendChild(eyeR);

        // Progress Bar (Secondary)
        this.progress = document.createElement('div');
        this.progress.style.position = 'absolute';
        this.progress.style.bottom = '20%';
        this.progress.style.left = '50%';
        this.progress.style.transform = 'translateX(-50%)';
        this.progress.style.width = '200px';
        this.progress.style.height = '20px';
        this.progress.style.border = `2px solid ${this.secondaryColor}`;
        this.progress.style.borderRadius = '10px';
        this.container.appendChild(this.progress);

        this.fill = document.createElement('div');
        this.fill.style.width = '0%';
        this.fill.style.height = '100%';
        this.fill.style.background = this.secondaryColor;
        this.fill.style.borderRadius = '8px';
        this.progress.appendChild(this.fill);

        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (!this.active) return;
        this.isRubbing = true;
        this.lastX = e.clientX;
        this.lastY = e.clientY;
    }

    onMove(e) {
        if (!this.active || !this.isRubbing) return;

        const dx = Math.abs(e.clientX - this.lastX);
        const dy = Math.abs(e.clientY - this.lastY);
        const dist = Math.sqrt(dx * dx + dy * dy);

        this.rubAmount += dist;
        this.lastX = e.clientX;
        this.lastY = e.clientY;

        // Visual feedback
        const pct = Math.min(100, (this.rubAmount / 1500) * 100); // 1500px total movement
        this.fill.style.width = `${pct}%`;

        if (pct >= 100) {
            this.win();
            this.robot.style.animation = 'none'; // Stop shaking
            this.robot.style.background = this.secondaryColor; // Happy color
            // Add hearts?
            const heart = document.createElement('div');
            heart.innerHTML = '❤️';
            heart.style.position = 'absolute';
            heart.style.top = '-40px';
            heart.style.fontSize = '3rem';
            heart.style.animation = 'floatUp 1s forwards';
            this.robot.appendChild(heart);
        }
    }

    onUp() {
        this.isRubbing = false;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
